import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

// 从环境变量读取配置
// const firebaseConfig = {
//   apiKey: process.env.UMI_APP_FB_API_KEY,
//   authDomain: process.env.UMI_APP_FB_AUTH_DOMAIN,
//   projectId: process.env.UMI_APP_FB_PROJECT_ID,
//   storageBucket: process.env.UMI_APP_FB_STORAGE_BUCKET,
//   messagingSenderId: process.env.UMI_APP_FB_MESSAGING_SENDER_ID,
//   appId: process.env.UMI_APP_FB_APP_ID
// };
const firebaseConfig = {
    apiKey: "AIzaSyCeyeM9iV1K_RNGqcEA5DV_0Xn6BSKXTe0",
    authDomain: "wlht-game.firebaseapp.com",
    projectId: "wlht-game",
    storageBucket: "wlht-game.firebasestorage.app",
    messagingSenderId: "557034908098",
    appId: "1:557034908098:web:8a3e74e366b7426d874e5b"
  };

// 初始化 Firebase 应用
const firebaseApp = initializeApp(firebaseConfig);

// 在初始化后添加验证代码
console.log('Firebase initialized with config:', {
  projectId: firebaseConfig.projectId?.substring(0, 6) + '...',
  authDomain: firebaseConfig.authDomain
});

// 导出认证实例
export const auth = getAuth(firebaseApp);

// 可选：按需导出其他 Firebase 服务
// export const firestore = getFirestore(firebaseApp);
// export const storage = getStorage(firebaseApp);